import { getAuth } from "@firebase/auth";
import { useEffect, useState } from "react";
import DeleteBook from "../../../../Controllers/Admin/SchoolLibrary/DeleteBook";
import GetAllBooks from "../../../../Controllers/Admin/SchoolLibrary/GetAllBooks";
import GetUser from "../../../../Controllers/Users/GetUser";
import { ToastSuccessMessages } from "../../../../Helpers/ToastMessages";

export default function SchoolLibraryListingViewModel() {
  const [BookID, setBookID] = useState("");
  const [SchoolID, setSchoolID] = useState("");
  const [IsLoading, setIsLoading] = useState(false);
  const [Refresh, setRefresh] = useState(true);

  useEffect(() => {
    const items = JSON.parse(localStorage.getItem("schoolId"));
    setSchoolID(items);
  }, []);

  const [AuthUser, setAuthUser] = useState();
  const [BooksArray, setBooksArray] = useState([]);

  const HandleRefresh = () => {
    setRefresh(!Refresh);
  };

  useEffect(() => {
    async function fetchData() {
      getAuth().onAuthStateChanged(async (user) => {
        const UserData = await GetUser(user?.uid);
        setAuthUser(UserData);
      });
    }
    fetchData();
  }, []);

  useEffect(() => {
    async function fetchData() {
      setIsLoading(true);
      const BooksData = await GetAllBooks(AuthUser?.uid, SchoolID);
      setBooksArray(BooksData);
      setIsLoading(false);
    }
    fetchData();
  }, [AuthUser?.uid, SchoolID, Refresh]);

  // Action Confirmation Start
  const [DeleteDialog, setDeleteDialog] = useState(false);

  const handleOpenDeleteDialog = (id) => {
    setBookID(id);
    setDeleteDialog(true);
  };

  const handleCloseDeleteDialog = async (del) => {
    setDeleteDialog(false);
    if (del === true) {
      await DeleteBook(BookID);
      ToastSuccessMessages("book/delete-successful");
      HandleRefresh();
      setDeleteDialog(false);
    }
  };
  // Action Confirmation End

  return {
    DeleteDialog,
    handleOpenDeleteDialog,
    handleCloseDeleteDialog,
    BooksArray,
    IsLoading,
  };
}
